export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  clinical_review: "Clinical Review",
  workflow_template: "Workflow",
  supplemental: "Supplemental",
  static_page: "Static Page",
}
